import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { Data2Service } from '../../common/data2.service';

import { LeadsListFiltersComponent } from '../leads-list-filters/leads-list-filters.component';

@Component({
	selector: 'app-leads-list',
	templateUrl: './leads-list.component.html',
	styleUrls: ['./leads-list.component.css'],
})
export class LeadsListComponent implements OnInit {
	@ViewChild('fileMovie', { static: false }) fileMovie;
	uploadProgress;
	showProgress = false;
	files: Set<File> = new Set();
	private itemsBeforeDataLoad = 5;
	loader = false;
	leads = [];
	count = 0;
	countLimit = 500;
	filters = {};
	forceFilters = {};
	tableRows = [
		{ id: 'type', icon: true },
		{ id: 'name', name: 'Nazwisko i Imię' },
		{ id: 'status', name: 'Status' },
		{ id: 'email1', name: 'E-mail' },
		{ id: 'phone1', name: 'Telefon' },
		{ id: 'note', name: 'Notatka' },
		{ id: 'created', name: 'Data utworzenia' },
		{ id: 'updated', name: 'Data aktualizacji' },
		{ id: 'owner', name: 'Opiekun' },
		{ id: 'source', name: 'Żródło' },
	];
	statuses = [];
	sources = [];
	types = [];
	users = [];

	constructor(
		private readonly api: Data2Service,
		private readonly route: ActivatedRoute,
		protected router: Router,
	) {}

	ngOnInit(): void {
		if (!this.route.snapshot.url[1]) {
			this.router.navigate([this.route.snapshot.url[0].path, 'individual']);
			return;
		}
		this.loader = true;
		this.forceFilters = {
			type: this.route.snapshot.url[1].path == 'individual' ? 1 : 2,
		};
		this.api.get('/leadsStatuses/', (result, error) => {
			this.statuses = result.data;
			this.loadData();
		});
		this.api.get('/leadsTypes/', (result, error) => {
			this.types = result.data;
			this.loadData();
		});
		this.api.get('/leadsSources/', (result, error) => {
			this.sources = result.data;
			this.loadData();
		});
		this.api.get('/users/', (result, error) => {
			this.users = result.data;
			this.loadData();
		});
	}

	private loadData(): void {
		this.itemsBeforeDataLoad--;
		if (this.itemsBeforeDataLoad > 0) {
			return;
		}
		this.loader = true;
		let parms: string = this.api.getChecked(this.filters);
		parms += '&limit=' + this.countLimit;
		this.api.get('/leads/?' + parms, (result, error) => {
			this.count = result.data.count;
			result.data.data.forEach((obj) => {
				const status = this.statuses.find((findObj) => findObj.id == obj.status);
				obj.status = status ? status.name : '?';
				const source = this.sources.find((findObj) => findObj.id == obj.source);
				obj.source = source ? source.name : '?';
				const owner = this.users.find((findObj) => findObj.id == obj.owner);
				obj.owner = owner ? owner.lastName + ' ' + owner.firstName : '?';
				const type = this.types.find((findObj) => findObj.id == obj.type);
				obj.type = type ? type.icon : '?';
				const background: string = status ? '#' + status.color : null;
				const foreground: string = this.colorIsDark(background) ? '#ffffff' : '#000000';
				obj.style = {
					background: background,
					color: foreground,
				};
			});
			this.leads = result.data.data;
			this.loader = false;
		});
	}

	addFiles() {
		this.fileMovie.nativeElement.click();
	}

	onFilesAdded(event) {
		const fileList: FileList = event.target.files;
		if (fileList.length <= 0) {
			return;
		}
		const file: File = fileList[0];
		const formData: FormData = new FormData();
		formData.append('uploadFile', file, file.name);

		this.loader = true;
		const fileElement = this.fileMovie;

		const files: { [key: string]: File } = fileElement.nativeElement.files;
		for (const key in files) {
			if (!isNaN(parseInt(key))) {
				this.files.add(files[key]);
			}
		}

		// Start the upload and save the progress map
		this.uploadProgress = this.api.upload('/leads', this.files);

		for (const key in this.uploadProgress) {
			this.uploadProgress[key].progress.subscribe((val) => {
				if (val == 100) {
					this.loader = false;
				}
			});
		}
	}

	filtersOpen() {
		new LeadsListFiltersComponent(this.api, this.route, this.router).filtersOpen();
	}

	filtersSelected(data) {
		this.filters = data;
		this.loadData();
	}

	// public setNumberOfResults()
	// {
	// 	this.loadData();
	// }

	private colorIsDark(color) {
		if (!color) {
			return false;
		}
		// Variables for red, green, blue values
		let r, g, b, hsp;
		// Hex --> RGB
		color = +('0x' + color.slice(1).replace(color.length < 5 && /./g, '$&$&'));
		r = color >> 16;
		g = (color >> 8) & 255;
		b = color & 255;
		// HSP (Highly Sensitive Poo) equation from http://alienryderflex.com/hsp.html
		hsp = Math.sqrt(0.299 * (r * r) + 0.587 * (g * g) + 0.114 * (b * b));
		// Using the HSP value, determine whether the color is light or dark
		if (hsp > 150) {
			return false;
		}
		return true;
	}
}
